import {gsap} from "gsap";
import {tweens_arrays_apparition as tween_big_title} from "../../../miscellaneous/bigTitle";
window.$ = window.jQuery = require('jquery');

const animationEnter = (container) => {
    console.log("Animation enter du la page contact");
    /**
     * Nous n'animons que le titre de page (en haut à droite)  ainsi que la balise #main
     * pour pouvoir garder le menu toujours visible
     * @type {jQuery}
     */
    const menu = $(container).find("#nav-wrapper").first();

    const tl = gsap.timeline({
        defaults : {
            duration:.5,
            ease: "power1.out",
        }
    });

    const page_title = $(container).find("#page-title").first();

    tl
        .add(tween_big_title)
        .from([menu,page_title], {autoAlpha: 0})
        .from("#contact-container", {autoAlpha:0}, '-=0.25')


    return tl;
}

export default animationEnter;